module.exports = __webpack_public_path__ + "static/media/archer-fire.e20ca0d3.gif";